import React, { useEffect, useMemo, useState } from "react";
import { Modal } from "react-bootstrap";
import { useProjectUIContext } from "../ProjectUIContext";
import { ProjectEditForm } from "./ProjectEditForm";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../_redux/project/projectAction";
import { toast } from "react-toastify";
import { toastOption } from "../../../../../_metronic/_helpers";
import { Formik } from "formik";
import ProgramTable from "./ProgramTable";
import ProgramModal from "./ProgramModal";
import { getProjectInitialValues, initValue } from "../ProjectUIHelpers";
import LoadingAnimation from "../loading-animation/LoadingAnimation";

export const ProjectEditDialog = ({
  match: {
    params: { id }
  },
  history
}) => {
  const [programModal, setProgramModal] = useState(false);
  const [programData, setProgramData] = useState([]);
  // ! VARIABLE FOR EDIT
  const [programRemoved, setProgramRemoved] = useState([]);
  const [programAdded, setProgramAdded] = useState([]);

  // Project Redux state
  const dispatch = useDispatch();
  const { actionsLoading, projectForEdit, error } = useSelector(
    state => ({
      actionsLoading: state.project.actionsLoading,
      projectForEdit: state.project.projectForEdit,
      error: state.project.error
    }),
    shallowEqual
  );

  if (error) {
    toast.error(error, toastOption);
  }
  useEffect(() => {
    // server call for getting Project by id
    dispatch(actions.fetchProject(id));
  }, [id, dispatch]);

  useEffect(() => {
    if (id && projectForEdit) {
      setProgramData(projectForEdit.program);
    }
  }, [id, projectForEdit]);

  const saveProject = project => {
    if (!id) {
      dispatch(actions.createProject(project)).then(response => {
        toast.success("Project succesfully created!", toastOption);
        history.push("/_distribution/project");
      });
    } else {
      delete project.program;
      dispatch(
        actions.updateProject({
          ...project,
          program_added: programAdded,
          program_removed: programRemoved
        })
      ).then(response => {
        toast.success("Project succesfully updated!", toastOption);
        history.push("/_distribution/project");
      });
    }
  };

  const addProgramFunc = value => {
    setProgramData(prev => {
      const old = [...prev];
      const sameValue = old.some(item => item.uuid === value.uuid);
      if (!sameValue) {
        old.push(value);
      }
      setProgramData(old);
    });

    // ! FOR PROGRAM ADDED
    if (id)
      setProgramAdded(prev => {
        const old = [...prev];
        const sameValue = old.some(item => item.uuid === value.uuid);
        const checkValueFromEdit = projectForEdit.program.some(
          item => item.uuid === value.uuid
        );
        if (!sameValue && !checkValueFromEdit) {
          old.push(value.uuid);
        }
        setProgramAdded(old);
      });
  };

  const removeProgramFunc = value => {
    setProgramData(prev => {
      const old = [...prev];
      const newData = old.filter(item => item.uuid !== value.uuid);
      setProgramData(newData);
    });
    // ! FOR PROGRAM DELETED
    if (id)
      setProgramRemoved(prev => {
        const old = [...prev];
        const sameValue = old.some(item => item.uuid === value.uuid);
        const checkValueFromEdit = projectForEdit.program.some(
          item => item.uuid === value.uuid
        );

        if (!sameValue && checkValueFromEdit) {
          old.push(value.uuid);
        }
        setProgramRemoved(old);
      });
  };

  return (
    <>
      <LoadingAnimation open={actionsLoading} />
      <ProgramModal
        show={programModal}
        onHide={() => setProgramModal(false)}
        selectedRow={addProgramFunc}
      />
      <Formik
        enableReinitialize={true}
        initialValues={getProjectInitialValues(projectForEdit)}
        onSubmit={values => saveProject({ ...values, program: programData })}
      >
        {({ handleSubmit, setFieldValue, values }) => (
          <>
            <ProjectEditForm
              saveProject={saveProject}
              history={history}
              setFieldValue={setFieldValue}
              values={values}
            />
            <ProgramTable
              handleSubmit={handleSubmit}
              programModal={() => setProgramModal(true)}
              data={programData}
              deleteRow={removeProgramFunc}
            />
          </>
        )}
      </Formik>
    </>
  );
};
